



































































































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator.ts";

@Component
export default class NoticiasComponent extends Mixins(FormValidator) {
  private aNoticias: any = [];
  private currentPage = 1;
  private total = 0;
  private mostrar: any = null; 

  @Watch("currentPage")
  private currentPageWatch(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 9)) {
      this.getNoticias();
    }
  }

  private mounted() {
    this.getNoticias();
  }

  private getNoticias() {
    this.$q.loading.show({
      delay: 100, // ms
    });
    this.$axios
      .get("noticias?pagina=" + this.currentPage)
      .then((res: any) => {
        this.mostrar = true;
        this.aNoticias = res.data.noticias;
        for (let i = 0; i < this.aNoticias.length; i++) {
          if (this.aNoticias[i].imagenes && this.aNoticias[i].imagenes.length > 0) {
            for (let j = 0; j < this.aNoticias[i].imagenes.length; j++) {
              this.aNoticias[i].imagenes[j].imagen =
                "https://d1rofaen6s22p4.cloudfront.net/" +
                this.aNoticias[i].imagenes[j].imagen;
            }
          } else {
            this.aNoticias[i].imagenes = [{
              imagen: require("@/assets/logos/logo-default.png")
            }];
          }
        }
        this.total = res.data.total;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.mostrar = false;
        console.log(err);
      });
  }

  private irNoticia(idNoticia: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "PublicacionNoticia" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "PublicacionNoticia",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private fechaPublicacion(fechaInicio: any) {
    const anhoInicio = fechaInicio.substring(0, 4);
    let mesInicio: any = parseInt(fechaInicio.substring(5, 7), 10);
    const diaInicio = fechaInicio.substring(8, 10);
    const hora = fechaInicio.substring(11, 16);

    if (mesInicio == 1) {
      mesInicio = "enero";
    } else if (mesInicio == 2) {
      mesInicio = "febrero";
    } else if (mesInicio == 3) {
      mesInicio = "marzo";
    } else if (mesInicio == 4) {
      mesInicio = "abril";
    } else if (mesInicio == 5) {
      mesInicio = "mayo";
    } else if (mesInicio == 6) {
      mesInicio = "junio";
    } else if (mesInicio == 7) {
      mesInicio = "julio";
    } else if (mesInicio == 8) {
      mesInicio = "agosto";
    } else if (mesInicio == 9) {
      mesInicio = "septiembre";
    } else if (mesInicio == 10) {
      mesInicio = "octubre";
    } else if (mesInicio == 11) {
      mesInicio = "noviembre";
    } else {
      mesInicio = "diciembre";
    }

    if (mesInicio != 0) {
      return diaInicio + " de " + mesInicio + " " + anhoInicio;
    }
  }
}
